import React from 'react';

const items = [
  { title: 'Curated Network',    desc: 'Every creator in our network is individually vetted for content quality, audience authenticity, and brand readiness.' },
  { title: 'Strategy First',     desc: "We don't just connect you — we build a campaign strategy tailored to your specific goals and audience." },
  { title: 'Full Transparency',  desc: 'Clear deliverables, honest timelines, and open communication from kickoff to final report.' },
  { title: 'Long-Term Thinking', desc: 'We care about sustainable results and lasting relationships — not just one-off campaigns.' },
];

export default function Results() {
  return (
    <section id="results" className="section-pad" style={{ padding: '120px 56px', background: 'var(--hero-bg)', borderTop: '1px solid #1e1e1e' }}>
      <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginBottom: '72px', flexWrap: 'wrap', gap: '24px' }}>
          <div>
            <div style={{ fontFamily: 'var(--font-body)', fontSize: '12px', fontWeight: 700, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--accent)', marginBottom: '16px' }}>
              Why Niles Ascend
            </div>
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(32px, 4vw, 60px)', fontWeight: 900, lineHeight: 1, color: 'var(--white)', textTransform: 'uppercase', letterSpacing: '-0.02em' }}>
              Built for Brands<br />and Creators<br />Who Are Serious
            </h2>
          </div>
        </div>

        <div
          className="results-grid"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '1px',
            background: '#1e1e1e',
            border: '1px solid #1e1e1e',
          }}
        >
          {items.map((item, i) => (
            <div key={i} style={{ padding: '44px 36px', background: '#111111' }}>
              <div style={{ fontFamily: 'var(--font-body)', fontSize: '12px', fontWeight: 700, letterSpacing: '0.12em', color: 'var(--accent)', marginBottom: '20px' }}>
                0{i + 1}
              </div>
              <div style={{ fontFamily: 'var(--font-display)', fontSize: '22px', fontWeight: 800, color: 'var(--white)', marginBottom: '16px', lineHeight: 1.2, textTransform: 'uppercase' }}>
                {item.title}
              </div>
              <div style={{ fontFamily: 'var(--font-body)', fontSize: '14px', fontWeight: 400, color: 'rgba(255,255,255,0.45)', lineHeight: 1.75 }}>
                {item.desc}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
